import { render, staticRenderFns } from "./userImageModal.vue?vue&type=template&id=6fdbad9b&scoped=true&"
import script from "./userImageModal.vue?vue&type=script&lang=js&"
export * from "./userImageModal.vue?vue&type=script&lang=js&"
import style0 from "./userImageModal.vue?vue&type=style&index=0&id=6fdbad9b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdbad9b",
  null
  
)

export default component.exports